import './scss/main.scss';

//svg sprite
import './img/svg/arrow-left.svg';
import './img/svg/arrow-right.svg';
import './img/svg/cart.svg';
import './img/svg/cart-header.svg';
import './img/svg/cart-page.svg';
import './img/svg/cart-go.svg';
import './img/svg/catalog.svg';
import './img/svg/check.svg';
import './img/svg/close.svg';
import './img/svg/comparison.svg';
import './img/svg/comparison-plus.svg';
import './img/svg/comparison-plus-active.svg';
import './img/svg/delete.svg';
import './img/svg/down.svg';
import './img/svg/email.svg';
import './img/svg/filters.svg';
import './img/svg/left.svg';
import './img/svg/like.svg';
import './img/svg/like-active.svg';
import './img/svg/like-page.svg';
import './img/svg/notification.svg';
import './img/svg/place.svg';
import './img/svg/profile.svg';
import './img/svg/profile-auth.svg';
import './img/svg/right.svg';
import './img/svg/search.svg';
import './img/svg/tel.svg';
import './img/svg/up.svg';
import './img/svg/home.svg';
import './img/svg/vk.svg';
// import './img/svg/sort-table.svg';
// import './img/svg/sort-list.svg';
import './img/svg/file.svg';
import './img/svg/edit.svg';

// scripts
import './js/common/global';
import { initAttributes } from './js/modules/atrtibutes';
import { initScrollBar } from './js/modules/scrollbar';
import { initLazyload } from './js/modules/lazy-load';
import { initBtnsClick } from './js/modules/click-btns';
import { initMenu } from './js/modules/aside-menu';
import { initSliders } from './js/modules/sliders';
import { initModals } from './js/modules/modals';
import { initToggle, refreshToggle } from './js/modules/toggle';
import { initTabs } from './js/modules/tabs';
import { initForm } from './js/modules/form';
import { initValidation } from './js/modules/validation';
import { initTooltip } from './js/modules/tooltip';
import { initAutosizeTextarea } from './js/modules/autosize-textarea';
import { initRange } from './js/modules/range';
import { initFilter } from './js/modules/filter';
import { initMap } from './js/modules/map';
import { initCart } from './js/modules/cart';
import { initCitySearch } from './js/modules/city-search';
import { initCompare } from './js/modules/compare';
import { initHeaderScroll } from './js/modules/header-scroll';
import { initProdDetailFooter } from './js/modules/prod-detail-footer';
import { initProductDescription } from './js/modules/product-description';
import { initZoom } from './js/modules/zoom';
import { initBtnTooltip } from './js/modules/btn-tooltip';
import { initPopup } from './js/modules/popups';
import { initSearch } from './js/modules/search';
import { initPhotosInput } from './js/modules/upload-photos-preview';

window.addEventListener(`DOMContentLoaded`, function () {
    initAttributes();
    initLazyload();

    initScrollBar();
    initBtnsClick();
    initMenu();
    initSliders();
    initModals();
    initToggle();
    initTabs();
    initForm();
    initValidation();
    initTooltip();
    initAutosizeTextarea();
    initRange();
    initFilter();
    initMap();
    initCart();
    initCitySearch();
    initCompare();
    initHeaderScroll();
    initProdDetailFooter();
    initProductDescription();
    initZoom();
    initBtnTooltip();
    initPopup();
    initSearch();
    initPhotosInput();
});

window.addEventListener(`resize`, function () {
    initAttributes();
});

window.addEventListener(`orientationchange`, () => {
    initAttributes();
});

window.refreshScripts = () => {
    initTooltip();
    initValidation();
    initSliders();
    initLazyload();
    initTabs();
    initToggle();
    // refreshToggle();
    // initCitySearch();

    document.querySelectorAll(`.video-js`).forEach((block) => {
        window.videojs(block, {}, function(){
            console.log('video js init');
        });
    });
};
